module.exports = __webpack_public_path__ + "img/logo_whole.7b51bdf7.svg";